import { Component, Input, OnInit } from '@angular/core';
import { INews } from '../news-panel/news-panel.component';

@Component({
  selector: 'app-news-component',
  templateUrl: './news-component.component.html',
  styleUrls: ['./news-component.component.scss']
})
export class NewsComponentComponent implements OnInit {

  /**
   * The news item.
   *
   * @type {INews}
   * @memberof NewsComponentComponent
   */
  @Input() new: INews;
  /**
    * Blank image when no photo is provided
    *
    * @memberof NewsPanelComponent
  */
  // tslint:disable-next-line:max-line-length
  blankImage = "/themes/custom/wa_radix/images/backgrounds/article-default-image.png"

  constructor() { }

  ngOnInit() {
  }

}
